export default "__VITE_ASSET__DFwbr4OS__"